import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HizmetDetay from '../../components/HizmetDetay';
import buzdolabiResmi from '../../assets/buzdolabı-teknik-servis.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

function BuzdolabiServisi() {
  // --- AOS VE DİNAMİK BAŞLIK AYARI ---
  useEffect(() => {
    // Sekme ismini kesin olarak çakıyoruz
    document.title = "Ankara Buzdolabı Teknik Servis | 7/24 Garantili Tamir";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // --- GOOGLE İÇİN ÖZEL BUZDOLABI SERVİS ŞEMASI (JSON-LD) ---
  const fridgeServiceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Buzdolabı Teknik Servis",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881",
      "areaServed": "Ankara"
    },
    "description": "Ankara genelinde Arçelik, Samsung, Beko ve tüm markalar için 7/24 profesyonel buzdolabı tamiri. Motor değişimi, gaz dolumu ve kart onarımı garantili yapılır.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Buzdolabı Onarım Hizmetleri",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Buzdolabı Motor (Kompresör) Değişimi" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Buzdolabı Gaz Dolumu" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "No-Frost Fan ve Rezistans Tamiri" } }
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>Ankara Buzdolabı Teknik Servis | 7/24 Garantili Tamir</title>
        <meta name="description" content="Ankara'da Arçelik, Samsung, Beko buzdolabı arızaları için 7/24 garantili teknik servis. Aynı gün motor değişimi ve gaz dolumu. Hemen arayın!" />
        {/* Google botları için teknik veri kartı */}
        <script type="application/ld+json">
          {JSON.stringify(fridgeServiceSchema)}
        </script>
      </Helmet>

      <div data-aos="fade-up">
        <HizmetDetay 
          icon="❄️"
          baslik="Ankara Buzdolabı Teknik Servis"
          stat1="Uzman Tamir"
          stat2="Aynı Gün"
          resim={buzdolabiResmi}
          aciklama="Buzdolabınızdaki her türlü arıza için Ankara genelinde hızlı, garantili ve tam donanımlı profesyonel onarım çözümleri sunuyoruz."
          seoMetni={(
            <>
              {/* SEO KART 1: GENEL HİZMET */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="100">
                <h4>Ankara'nın Lider Buzdolabı Servisi</h4>
                <p>
                  Evinizin en kritik beyaz eşyası olan buzdolabınız arızalandığında, hızlı ve güvenilir bir <strong>buzdolabı teknik servis</strong> desteği almak hayati önem taşır. Yılların tecrübesiyle Başkent'in her noktasına ulaşan <strong>ankara buzdolabı tamircisi</strong> ekiplerimizle cihazınızın ilk günkü performansına dönmesini sağlıyoruz.
                </p>
              </div>

              {/* SEO KART 2: YERLİ MARKALAR */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="200">
                <h4>Yerli Cihazlarda Kusursuz Onarım</h4>
                <p>
                  Türkiye'nin en çok tercih edilen markalarında, <strong>ankara buzdolabı yetkili</strong> servis standartlarında hizmet veriyoruz. Motor (kompresör) yanması veya gaz kaçağı gibi durumlarda tam donanımlı <strong>arçelik buzdolabı teknik servis</strong> ve <strong>beko buzdolabı teknik servis</strong> ekiplerimizle kapınızdayız.
                </p>
              </div>

              {/* SEO KART 3: SAMSUNG UZMANLIĞI */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="300">
                <h4>Samsung Cihazlarda Uzmanlık</h4>
                <p>
                  Gelişmiş dijital teknolojilere sahip cihazların ana kart ve sensör onarımlarında <strong>samsung ankara buzdolabi servisi</strong> taleplerinize sertifikalı teknisyenlerimizle yanıt veriyoruz. Dijital ekran hatalarını ve soğutma kayıplarını yerinde, garantili çözüyoruz.
                </p>
              </div>

              {/* SEO KART 4: GENEL GÜVEN */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="400">
                <h4>Garantili ve Kesin Çözüm Merkezi</h4>
                <p>
                  Hangi marka olursa olsun, nitelikli <strong>buzdolabı teknik servis</strong> hizmetini tek bir çatı altında topladık. Kesintisiz soğutma performansı ve uzun ömürlü cihazlar için <strong>ankara buzdolabı yetkili</strong> kalitesinde 7/24 yanınızdayız.
                </p>
              </div>
            </>
          )}
        />
      </div>
    </>
  );
}

export default BuzdolabiServisi;